<template>
  <div v-if="isShowingLoading" class="box-loading">
    <LoadingSpinner />
  </div>

  <router-view :class="{'hide-all': isShowingLoading}" />

  <WithdrawalModal v-if="showWithdrawalModal" :show-modal="showWithdrawalModal" />

  <DepositModal v-if="showDepositModal" :show-modal="showDepositModal" />
  
  <CreateUserModal v-if="showCreateUSerModal" :show-modal="showCreateUSerModal" />
</template>

<script>

import LoadingSpinner from '@/components/LoadingSpinner.vue';
import WithdrawalModal from '@/components/modals/WithdrawalModal.vue';
import DepositModal from '@/components/modals/DepositModal.vue';
import CreateUserModal from '@/components/modals/CreateUserModal.vue';

export default {
  name: 'App',

  components: {
    LoadingSpinner,
    WithdrawalModal,
    DepositModal,
    CreateUserModal
  },

  computed: {
    isShowingLoading() {
      return this.$store.getters['helpers/isShowingLoading'];
    },
    showWithdrawalModal() {
      return this.$store.getters['modals/isShowingModalWithdrawal']
    },
    showDepositModal() {
      return this.$store.getters['modals/isShowingModalDeposit']
    },
    showCreateUSerModal() {
      return this.$store.getters['modals/isShowingModalCreateUser']
    }
  },

  mounted() {
    this.$store.dispatch('device/checkDevice');
    window.addEventListener('resize', () => {
      this.$store.dispatch('device/checkDevice');
    });
  }
}
</script>

<style lang="scss">
#app {
  height: 100%;
  width: 100%;
  display: flex;
}

.hide-all {
  opacity: 0;
}

.box-loading {
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100000;
}
</style>
